// Module
var code = "<script>let $ctrl</script> <button class=\"button button--blue\" type=\"button\" title=\"{{ $ctrl.buttonTitle }}\" ng-click=\"$ctrl.callback()\" ng-disabled=\"$ctrl.disabled\" name=\"button-blue\"> <atom-text class=\"button__text\"> <ng-transclude></ng-transclude> </atom-text> </button> ";
// Exports
module.exports = code;